export const GET_PARTNERS = 'GET_PARTNERS';
export const UPDATE_PARTNERS = 'UPDATE_PARTNERS';
export const FETCH_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG =
  'FETCH_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG';
export const UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG =
  'UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG';
export const UPDATE_SHOWROOM_CAMPAIGN_SELECTED = 'UPDATE_SHOWROOM_CAMPAIGN_SELECTED';
export const UPDATE_CAMPAIGN_SELECTED = 'UPDATE_CAMPAIGN_SELECTED';
